import { Box, Typography, Tooltip } from "@mui/material";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { InfoOutlined } from '@mui/icons-material';

type Props = {
  validationErrors: any[];
  showValidationErrors: boolean;
};

export default function CampaignTextValidationErrors({ validationErrors, showValidationErrors }: Props) {
  if (!showValidationErrors || !validationErrors.length) return null;

  return (
    <Box sx={styles.validationContainer}>
      <Box sx={styles.validationHeader}>
        <WarningAmberIcon sx={styles.validationIcon} />
        <Typography variant="subtitle2" sx={styles.validationTitle}>
          AI Suggestions:
        </Typography>
      </Box>
      <Box sx={styles.validationList}>
        {validationErrors.map((error, index) => (
          <Box key={index} sx={styles.validationItem}>
            <Typography sx={styles.validationText}>
              {index + 1}. <span style={styles.validationToken}>{error.token}</span> - {error.message}
            </Typography>
            {error.tooltip && (
              <Tooltip title={error.tooltip}>
                <InfoOutlined sx={styles.validationTooltipIcon} />
              </Tooltip>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

const styles = {
  validationContainer: {
    backgroundColor: '#ff9800',
    border: 'none',
    borderRadius: '8px',
    padding: '8px',
    marginBottom: '12px',
    flexShrink: 0,
  },
  validationHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '6px'
  },
  validationIcon: {
    color: '#ffffff',
    marginRight: '6px',
    fontSize: '16px'
  },
  validationTitle: {
    fontWeight: 600,
    color: '#ffffff',
    fontSize: '12px'
  },
  validationList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px'
  },
  validationItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  validationText: {
    fontSize: '11px',
    color: '#ffffff',
    flex: 1,
    lineHeight: 1.3
  },
  validationToken: {
    fontWeight: 600,
    fontFamily: 'monospace',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    padding: '1px 3px',
    borderRadius: '3px',
    fontSize: '10px',
    color: '#ffffff'
  },
  validationTooltipIcon: {
    fontSize: '14px',
    color: '#ffffff',
    cursor: 'pointer'
  }
};
